import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'; import { Capacitor } from '@capacitor/core';
import { throwError, Observable, from } from 'rxjs'; import { TotpService } from './totp.service';
import { environment } from 'src/environments/environment';
import { IUserData } from '../@types/UserData'; import { switchMap } from 'rxjs/operators';
import { tap, retry, catchError, filter, map } from 'rxjs/operators';
import { firstValueFrom, of } from 'rxjs'; import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router'; import { Inject } from '@angular/core';
import { SanctumService } from 'src/app/services/sanctum.service';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { HttpErrorResponse } from '@angular/common/http'; import { BehaviorSubject } from 'rxjs';
import { PosthogService } from 'src/app/services/posthog.service';
@Injectable({
  providedIn: 'root' // from
})
export class AuthService {

  //////////////////////////

  private userSubject = new BehaviorSubject<IUserData | null>(null);
  public user$ = this.userSubject.asObservable();

  // setter público
  public setLoggedUser(user: IUserData) {
    this.userSubject.next(user);
    this.posthogService.identify(user.id, {
      email: user.email,
      name: user.name,
    });
  }

  public getLoggedUserId(): number | null {
    const raw = localStorage.getItem('user_id');
    return raw ? Number(raw) : null;
  }

  public clearUser() {
    this.userSubject.next(null);
    this.posthogService.reset();
  }
  //////////////////////////

  private path: string = 'auth'
  private httpOptions = {};
  constructor(
    private http: HttpClient, private router: Router,
    private totpService: TotpService,
    @Inject(DOCUMENT) private document: Document,
    private authHeaderService: AuthHeaderService,
    private sanctum: SanctumService,
    private posthogService: PosthogService
  ) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
  }

  // SanctumService




  wallet(): Promise<any[]> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/wallets`;

    const request$ = from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any[]>(url, httpOptions).pipe(
          catchError(() => of([])) // Retorna array vazio em caso de erro
        )
      )
    );

    return firstValueFrom(request$);
  }



  me(tokenFromLogin?: string): Observable<IUserData> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    return from(this.authHeaderService.getHttpOptions(tokenFromLogin)).pipe(
      switchMap((options) =>
        this.http.get<IUserData>(`${baseUrl}/auth/me`, options)
      )
    );
  }

  checkAndUpdateDeviceToken(): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap((options) =>
        this.http.get(`${baseUrl}/users/${localStorage.getItem('user_id')}/update_device_token`, options)
      )
    );
  }




  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }


  me2(): Observable<IUserData> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/${this.path}/me`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<IUserData>(url, {}, httpOptions)
          )
        )
      )
    );
  }


  forgot(email: string): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/${this.path}/forgot`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, { email }, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }

  socialOauthCallback(code: string, state: string): Observable<any> {
    let store_id;
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    if (selectedStoreId) store_id = Number(selectedStoreId);

    const baseUrl = `${environment.apiBaseUrl}/api`;

    // Altere o endpoint conforme sua rota backend (aqui exemplo Google)
    const url = `${baseUrl}/admin/store/${store_id}/google/oauth/callback`;

    return this.http.post<any>(url, { code, state }).pipe(
      catchError((error) => {
        console.error('Erro na autenticação social:', error);
        return throwError(() => error);
      })
    );
  }



  resetPassword(
    token: string,
    email: string,
    password: string,
    password_confirmation: string
  ): Observable<any> {
    const body = {
      email,
      password,
      password_confirmation,
      token
    };

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/${this.path}/reset`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, body, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }




  getAccessToken(): string {
    return localStorage.getItem("access_token") || '';
  }

  setAccessToken(access_token: string, clear: Boolean = true): void {
    if (clear) {
      localStorage.removeItem("access_token");

    }
    localStorage.setItem("access_token", access_token);
  }

  getSaleorToken(): string {
    return localStorage.getItem("saleor_token") || '';
  }

  setSaleorToken(saleor_token: string): void {
    localStorage.setItem("saleor_token", saleor_token);
  }

  getUser(): any {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null; // ou outro valor padrão
  }

  setUser(user: number): void {
    localStorage.setItem("user_id", JSON.stringify(user));
  }
  setUserName(user: string): void {
    localStorage.setItem("user_name", JSON.stringify(user));
  }
  setUserID(user: number): void {
    localStorage.setItem("user_id", JSON.stringify(user));
  }
  setUserTrial(user: string): void {
    localStorage.setItem("use_trial", JSON.stringify(user));
  }
  setUserAvatar(user: string): void {
    localStorage.setItem("user_avatar", JSON.stringify(user));
  }

  getWorkspace(): string {
    //return localStorage.getItem("workspace");
    return "loja";
  }

  isStoreWorkspace(): Boolean {
    return this.getWorkspace() == 'store';
  }

  isFinanceWorkspace(): Boolean {
    return this.getWorkspace() == 'finance';
  }

  setWorkspaceToFinance(): Promise<any> {
    return new Promise((resolve, reject) => {
      localStorage.setItem("workspace", 'finance')

      setTimeout(() => {
        if (this.getWorkspace() && this.getWorkspace() !== '') {
          resolve(true);
        } else {
          reject('sem storage');
        }
      }, 100);
    })
  }

  setWorkspaceToStore(): Promise<any> {
    return new Promise((resolve, reject) => {
      localStorage.setItem("workspace", 'store')

      setTimeout(() => {
        if (this.getWorkspace() && this.getWorkspace() !== '') {
          resolve(true);
        } else {
          reject('sem storage');
        }
      }, 100);
    })
  }


  async logout(): Promise<any> {
    // forceTokenAuth (ver login() acima): mesmo bug já corrigido lá — logout()
    // tinha seu próprio check de isNative independente, ignorando o flag e
    // sempre caindo no fluxo de sessão/CSRF, que não funciona em preview
    // cross-domain (frontend/backend em domínios não relacionados).
    const isMobileApp = Capacitor.isNativePlatform() || environment.forceTokenAuth;

    const url = `${environment.apiBaseUrl}/api/auth/logout`;

    if (isMobileApp) {
      const headers = await this.authHeaderService.getAuthHeaders(); // aqui ok ter Bearer
      return this.http.post(url, {}, { headers }).toPromise();
    }

    // WEB
    await this.sanctum.initSanctum?.(); // ok
    const headers = await this.authHeaderService.getWebOnlyHeaders(); // <- novo método
    return this.http.post(url, {}, { headers, withCredentials: true }).toPromise();
  }
  

  // async logout(): Promise<any> {
  //   const isNative = Capacitor.isNativePlatform();
  //   console.log('[Logout] Plataforma é mobile?', isNative);

  //   if (!isNative) {
  //     console.log('[Logout] Iniciando initSanctum para web');
  //     await this.sanctum.initSanctum?.();
  //   }

  //   const options = await this.authHeaderService.getHttpOptions();
  //   console.log('[Logout] Headers montados:', JSON.stringify(options, null, 2));

  //   const url = environment.production
  //     ? 'https://api.slicksell.com.br/api/auth/logout'
  //     : 'https://stage-api.slicksell.com.br/api/auth/logout';

  //   console.log('[Logout] URL final da requisição:', url);

  //   return this.http.post(url, {}, options).toPromise().then(res => {
  //     console.log('[Logout] Sucesso na resposta:', JSON.stringify(res, null, 2));
  //     return res;
  //   }).catch(err => {
  //     console.error('[Logout] Erro na resposta:', JSON.stringify(err, null, 2));
  //     throw err;
  //   });
  // }

  getStoreById(store_id: number): Observable<any[]> {
    const url = `${environment.apiBaseUrl}/api/public/admin/show_stores?store_id=${store_id}`;

    return from(this.authHeaderService.getPublicHttpOptions()).pipe(
      switchMap((httpOptions) => this.http.get<any[]>(url, httpOptions))
    );
  }



  async login(email: string, password: string): Promise<any> {
    // forceTokenAuth (environment.*.ts): mesmo fora de app nativo, força o
    // fluxo de token (X-Mobile-App/Bearer, já embutido em getHttpOptions()
    // via simulateNative) em vez de sessão/CSRF do Sanctum — usado só em
    // testes onde frontend/backend ficam em domínios não relacionados
    // (cookie de sessão cross-site não é confiável nesse caso).
    const isMobileApp = Capacitor.isNativePlatform() || environment.forceTokenAuth;

    const body = { email, password };

    const options = await this.authHeaderService.getHttpOptions();


    if (!isMobileApp) {
      await this.sanctum.initSanctum(); // garante o cookie XSRF-TOKEN

      const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
      const xsrfToken = match ? decodeURIComponent(match[1]) : null;

      if (xsrfToken) {
        options.headers = new HttpHeaders({
          'X-XSRF-TOKEN': xsrfToken
        });
      }
    }

    return this.http.post<any>(
      `${environment.apiBaseUrl}/api/auth/login`,
      body,
      options
    ).toPromise();
  }


  async verifyPhone(phone: string): Promise<{ exists: boolean }> {
    const isMobileApp = Capacitor.isNativePlatform();
    const body = { phone };
    const options = await this.authHeaderService.getHttpOptions();
    const apiUrl = `${environment.apiBaseUrl}/api/auth/verify-phone-creators`;
    // Retorna ou lança erro se não vier nada
    const res = await this.http.post<{ exists: boolean }>(apiUrl, body, options).toPromise();
    if (!res) throw new Error('Sem resposta do backend');
    return res;
  }

  async loginWithPhone(data: { phone: string; otp: string; name?: string }): Promise<any> {
    const isNative = Capacitor.isNativePlatform();
    const digits = data.phone.replace(/\D/g, '');
    const body: any = { phone: digits, otp: data.otp };
    if (data.name) body.name = data.name;

    const url = `${environment.apiBaseUrl}/auth/phone-login`;

    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';

    if (isNative || isLocalhost) {
      // ====== FLUXO MOBILE (JWT via api_creator) ======
      // NADA de CSRF/Sanctum aqui.
      const deviceHeaders = await this.authHeaderService.getDeviceHeaders?.(); // se você já tem
      const headersObj: Record<string, string> = {
        'Content-Type': 'application/json',
        'X-Mobile-App': 'true',
        'X-Auth-Context': 'creator',
        ...(deviceHeaders || {})
      };

      // Se quiser enviar TOTP já no login (opcional)
      try {
        const totp = await this.totpService.getCurrentCode();
        headersObj['X-App-Code'] = totp;
      } catch { }

      const headers = new HttpHeaders(headersObj);

      return this.http.post(url, body, {
        headers,
        // sem withCredentials
      }).toPromise();
    } else {
      // ====== FLUXO WEB (Sanctum com sessão krabo_creator_session) ======
      await this.sanctum.initSanctum('creator');

      const m = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
      const xsrf = m ? decodeURIComponent(m[1]) : '';

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Context': 'creator',
        'X-Requested-With': 'XMLHttpRequest',
        ...(xsrf ? { 'X-XSRF-TOKEN': xsrf } : {})
      });

      return this.http.post(url, body, {
        headers,
        withCredentials: true
      }).toPromise();
    }
  }







  /////////////////////////////////////
  apiUrl = 'https://slicksell.click';
  // Enviar OTP via WhatsApp
  async sendOtpWhatsApp(phone: string): Promise<any> {
    const isMobileApp = Capacitor.isNativePlatform();
    const body = { phone };
    const options = await this.authHeaderService.getHttpOptions();
    const apiUrl = `${environment.apiBaseUrl}/api/auth/send-otp-whatsapp`;
    return await this.http.post<any>(apiUrl, body, options).toPromise();
  }


  // Validar OTP (pode ser chamada dentro do submitOTP)
  validateOtp(phone: string, otp: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/validate-otp`, { phone, otp });
  }
  /////////////////////////////////////
}

